import { render, staticRenderFns } from "./swimming-athletes-photo.vue?vue&type=template&id=d2b5eb4a&scoped=true&"
import script from "./swimming-athletes-photo.vue?vue&type=script&lang=js&"
export * from "./swimming-athletes-photo.vue?vue&type=script&lang=js&"
import style0 from "./swimming-athletes-photo.vue?vue&type=style&index=0&id=d2b5eb4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b5eb4a",
  null
  
)

export default component.exports